import { FormSelect } from "@jsq/ds/forms";
import type { SelectOption } from "./types";

/**
 * Renders a `FormSelect.Section` of `FormSelect.Option` children for the
 * given options. Implemented as a render helper (not a component) because
 * `FormSelect` traverses `React.Children` looking for `Section`/`Option`
 * nodes directly — wrapping in a component would break that traversal.
 */
export const renderFormSelectOptions = <T extends string | number>(
  options: ReadonlyArray<SelectOption<T>>,
) => (
  <FormSelect.Section>
    {options.map((option) => (
      <FormSelect.Option key={option.value} value={option.value}>
        {option.label}
      </FormSelect.Option>
    ))}
  </FormSelect.Section>
);
